var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.973,
    y1: 0.997,
    x2: -0.004,
    y2: 0.106,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.981,
    y1: 0.984,
    x2: 0.021,
    y2: 0.047,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.078
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Email"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 42
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    clipPath: "url(#clip-Email)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(1 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 18.634,
    cy: 18.634,
    r: 18.634,
    transform: "translate(5.222 10.731)",
    fill: "#0070b6",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "send-24px",
    transform: "translate(10.791 14.042) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M.008,23.262,27.123,11.616.021,0,0,9.046,19.374,11.62,0,14.216Z",
    transform: "translate(0.961 8.096)",
    fill: "#0070b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1.146,0,19.73,5.786,0,2.326Z",
    transform: "translate(0 22.824) rotate(-25)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1.1,0l9.357,10.581,9.8,11.087L0,2.153Z",
    transform: "translate(0.012 8.562) rotate(-25)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 14.198,
    height: 1.183,
    rx: 0.592,
    transform: "translate(0 37.061) rotate(-30)",
    fill: "#0186b0",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 5.324,
    height: 1.183,
    rx: 0.592,
    transform: "translate(9.446 42.09) rotate(-30)",
    fill: "#0186b0",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 11.24,
    height: 1.183,
    rx: 0.592,
    transform: "translate(10.236 36.765) rotate(-30)",
    fill: "#0186b0",
    opacity: 0.21
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailus);
export default __webpack_public_path__ + "static/media/emailus.692236ef9005c51cf59f902ef4dbe9be.svg";
export { ForwardRef as ReactComponent };